import { UpdatePaymentLoginInfoApi } from "@/features/accounts/payment/scraping/services/update-login-info-api";
import { UpdatePaymentLoginInfoRequestModel } from "@/features/accounts/payment/scraping/services/update-login-info-model";

/// MoneyLook ログイン情報変更処理
export class UpdatePaymentLoginInfoService {
  private updatePaymentLoginInfoApi = new UpdatePaymentLoginInfoApi();

  /**
   * MoneyLook ログイン情報変更API実行
   */
  public async updatePaymentLoginInfo(param: UpdatePaymentLoginInfoRequestModel) {
    return await this.updatePaymentLoginInfoApi.updatePaymentLoginInfo(param);
  }
}
